function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SideBySideTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component";
import { StyledSideBySideWithIconsTextAndAssetDekstopComponent } from "./side-by-side-with-icons-text-and-asset-dekstop-component.scss.js";
import DefaultProps from "./default-props";
const SideBySideWithIconsTextAndAssetDekstopComponent = (props)=>{
    const getStyle = ()=>{
        const { minHeight } = props;
        if (!minHeight) return {};
        return {
            minHeight
        };
    };
    return /*#__PURE__*/ _jsx(StyledSideBySideWithIconsTextAndAssetDekstopComponent, {
        className: "side-by-side-with-icons-text-and-asset-component",
        style: getStyle(),
        children: /*#__PURE__*/ _jsx("div", {
            className: "side-by-side-asset-wrapper",
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAssetComponent, _object_spread({}, props))
        })
    });
};
SideBySideWithIconsTextAndAssetDekstopComponent.defaultProps = DefaultProps;
export default SideBySideWithIconsTextAndAssetDekstopComponent;
